export const SELECT_DEFAULT = 1
export const SELECT_ROUNDED = 2
export const SELECT_WHITE = 4
